import * as axiosBaseClient from './axiosBaseClient';
import configurations from '../config.json';
import { apiUrl } from "../httpCommon";

const baseURL = apiUrl();

export const getRegions = () => {
  const url = `${baseURL}${configurations.REGION_END_POINT}`;
  return axiosBaseClient.httpGet(url);
};

export const getCountries = (regionCode, isActive=false) => {
  const url = `${baseURL}${configurations.COUNTRY_END_POINT}?regions=${regionCode}&isActive=${isActive}`;
  return axiosBaseClient.httpGet(url);
};

export const getCurrencies = () => {
  const url = `${baseURL}${configurations.CURRENCY_END_POINT}`;
  return axiosBaseClient.httpGet(url);
};

export const getLookupData = (categoryCode) => {
  const url = `${baseURL}${configurations.LOOKUP_DATA_END_POINT}?categoryCode=${categoryCode}`;
  return axiosBaseClient.httpGet(url);
};